module.exports = __webpack_public_path__ + "static/media/art.37c4f64d.svg";